"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RU = exports.TRANSLATIONS = void 0;

/* eslint-disable no-template-curly-in-string */
var TRANSLATIONS = {
  en: {
    translation: {
      'send': 'Submit',
      'addQuestionBlock': 'Add',
      'remove': 'Remove',
      'optional': ' (optional)',
      'cancel': 'Cancel',
      'save': 'Save',
      'stopRecording': 'Stop recording',
      'startRecording': 'Start recording',
      'upload': 'Upload',
      'download': 'Download',
      'recordAudio': 'Record audio',
      'recordVideo': 'Record video',
      'takePhoto': 'Take a photo',
      'opdFormAccept': 'Accept',
      'opdLabel': 'I agree with',
      'opdLink': 'personal data processing',
      'opdOffertaLabel': 'I accept the terms',
      'opdOffertaLink': 'public offer',
      'MONTHS': [{
        value: 1,
        label: 'January'
      }, {
        value: 2,
        label: 'February'
      }, {
        value: 3,
        label: 'March'
      }, {
        value: 4,
        label: 'April'
      }, {
        value: 5,
        label: 'May'
      }, {
        value: 6,
        label: 'June'
      }, {
        value: 7,
        label: 'July'
      }, {
        value: 8,
        label: 'August'
      }, {
        value: 9,
        label: 'September'
      }, {
        value: 10,
        label: 'October'
      }, {
        value: 11,
        label: 'November'
      }, {
        value: 12,
        label: 'December'
      }],
      'loading': 'Loading...',
      'noOptionsMessage': 'There is no data',
      'otherOption': 'Other',
      'placeholders': {
        'datePicker': {
          'day': 'Day',
          'month': 'Month',
          'year': 'Year'
        },
        'salaryCurrency': 'Select currency...'
      },
      'errors': {
        'required': 'Required field',
        'minLength': 'Minimum letters count - {{count}}',
        'maxLength': 'Maximum letters count - {{count}}',
        'moreThan': 'Number must be greater than {{more}}',
        'currency': 'Currency required',
        'phone': 'Invalid phone number',
        'email': 'Invalid Email',
        'emailChars': 'Invalid Email (valid characters - letters numbers _ - .)',
        'emailDomain': 'Invalid Email domain (valid characters - letters numbers - .)',
        'audioPermission': 'Access to the microphone is blocked. Allow access to the microphone in the browser settings',
        'cameraPermission': 'Access to the camera is blocked. Allow access to the camera in the browser settings',
        'uploadError': 'Failed to upload file.',
        'maximumFileSize': 'Maximum file size: {{count}} megabyte',
        'maximumFileSize_plural': 'Maximum file size: {{count}} megabytes',
        'fileType': 'Invalid type, available types: {{types}}',
        'fileTypeAudio': 'Invalid type, select audio file',
        'fileTypeVideo': 'Invalid type, select video file',
        'composite': 'Required block',
        'incompleteDate': 'Full date is required',
        'captchaRequired': 'Verification required',
        'incorrectBirthDate': 'Date cant be earlier then birth date'
      },
      'invalidCaptcha': 'Invalid captcha',
      'licenseError': 'The maximum number of responses has been reached for test access. Contact the Sales Department of Geliosoft LLC and the contacts of the sales department (<a href=\"mailto:help@findy.ru\"> help@findy.ru </a>, <a href=\"tel:+74957836603\"> +7 (495) 783-66-03 </a> (9:00-18:00 Moscow time), <a href=\"tel:+79150216424\"> +7 (915) 021-64-24 </a>) ',
      'licenseExpired': 'The test access period "30 days" has expired. Contact the Sales Department of "Heliosoft" LLC and the contacts of the sales department (<a href="mailto:help@findy.ru"> help@findy.ru </a>, <a href="tel:+74957836603"> +7 (495) 783-66-03 </a> (9:00-18:00 Moscow time), <a href="tel: +79150216424"> + 7 (915) 021-64-24 </a>)'
    }
  },
  ru: {
    translation: {
      'send': 'Отправить',
      'addQuestionBlock': 'Добавить',
      'remove': 'Удалить',
      'optional': ' (опционально)',
      'cancel': 'Отмена',
      'save': 'Сохранить',
      'stopRecording': 'Остановить запись',
      'startRecording': 'Начать запись',
      'upload': 'Загрузить',
      'download': 'Cкачать',
      'recordAudio': 'Записать аудио',
      'recordVideo': 'Записать видео',
      'takePhoto': 'Сделать фото',
      'opdFormAccept': 'Согласен',
      'opdLabel': 'Я даю согласие на',
      'opdLink': 'обработку персональных данных',
      'opdOffertaLabel': 'Я принимаю условия',
      'opdOffertaLink': 'публичной оферты',
      'MONTHS': [{
        value: 1,
        label: 'Январь'
      }, {
        value: 2,
        label: 'Февраль'
      }, {
        value: 3,
        label: 'Март'
      }, {
        value: 4,
        label: 'Апрель'
      }, {
        value: 5,
        label: 'Май'
      }, {
        value: 6,
        label: 'Июнь'
      }, {
        value: 7,
        label: 'Июль'
      }, {
        value: 8,
        label: 'Август'
      }, {
        value: 9,
        label: 'Сентябрь'
      }, {
        value: 10,
        label: 'Октябрь'
      }, {
        value: 11,
        label: 'Ноябрь'
      }, {
        value: 12,
        label: 'Декабрь'
      }],
      'loading': 'Загрузка...',
      'noOptionsMessage': 'Нет данных',
      'otherOption': 'Другое',
      'placeholders': {
        'datePicker': {
          'day': 'День',
          'month': 'Месяц',
          'year': 'Год'
        },
        'salaryCurrency': 'Выберите валюту...'
      },
      'errors': {
        'required': 'Поле обязательно для заполнения',
        'minLength': 'Минимальное количество символов - {{count}}',
        'maxLength': 'Максимальное количество символов - {{count}}',
        'moreThan': 'Число должно быть больше {{more}}',
        'currency': 'Необходимо указать валюту',
        'phone': 'Неверный формат телефонного номера',
        'email': 'Неверный email',
        'emailChars': 'Неверный email (допустимые символы - латинские цифры _ - .)',
        'emailDomain': 'Неверный email домен (допустимые символы - латинские цифры - .)',
        'audioPermission': 'Доступ к микрофону заблокирован. Разрешите доступ к микрофону в настройках браузера',
        'cameraPermission': 'Доступ к камере заблокирован. Разрешите доступ к камере в настройках браузера',
        'uploadError': 'Не удалось загрузить файл',
        'maximumFileSize_0': 'Максимальный размер загружаемого файла: {{count}} мегабайт',
        'maximumFileSize_1': 'Максимальный размер загружаемого файла: {{count}} мегабайта',
        'maximumFileSize_2': 'Максимальный размер загружаемого файла: {{count}} мегабайт',
        'fileType': 'Неверный тип файла, доступные типы: {{types}}',
        'fileTypeAudio': 'Неверный тип файла, выберите аудиофайл',
        'fileTypeVideo': 'Неверный тип файла, выберите видеофайл',
        'composite': 'Блок обязателен для заполнения',
        'incompleteDate': 'Необходимо указать дату полностью',
        'captchaRequired': 'Необходимо пройти проверку',
        'incorrectBirthDate': 'Дата не может быть меньше даты рождения'
      },
      'invalidCaptcha': 'Неверно введена капча',
      'licenseError': 'В рамках тестового доступа достигнуто максимальное количество откликов. Обратитесь в Отдел продаж ООО "Гелиософт" и контакты отдела продаж (<a href=\"mailto:help@findy.ru\">help@findy.ru</a>, <a href=\"tel:+74957836603\">+7 (495) 783-66-03</a> (9:00-18:00 МСК), <a href=\"tel:+79150216424\">+7 (915) 021-64-24</a>)',
      'licenseExpired': 'Срок тестового доступа "30 дней" завершен. Обратитесь в Отдел продаж ООО "Гелиософт" и контакты отдела продаж (<a href="mailto:help@findy.ru">help@findy.ru</a>, <a href="tel:+74957836603">+7 (495) 783-66-03</a> (9:00-18:00 МСК), <a href="tel:+79150216424">+7 (915) 021-64-24</a>)'
    }
  },
  ua: {
    translation: {
      'send': 'Відправити',
      'addQuestionBlock': 'Додати',
      'remove': 'Видалити',
      'optional': ' (опціонально)',
      'cancel': 'Скасування',
      'save': 'Зберегти',
      'stopRecording': 'Зупинити запис',
      'startRecording': 'Почати запис',
      'upload': 'Завантажити',
      'download': 'Завантажити',
      'recordAudio': 'Записати аудіо',
      'recordVideo': 'Записати відео',
      'takePhoto': 'Зробити фото',
      'opdFormAccept': 'Згоден',
      'opdLabel': 'Я даю згоду на',
      'opdLink': 'обробку персональних даних',
      'opdOffertaLabel': 'Я приймаю умови',
      'opdOffertaLink': 'публічної оферти',
      'MONTHS': [{
        value: 1,
        label: 'Січень'
      }, {
        value: 2,
        label: 'Лютий'
      }, {
        value: 3,
        label: 'Березень'
      }, {
        value: 4,
        label: 'Квітень'
      }, {
        value: 5,
        label: 'Травень'
      }, {
        value: 6,
        label: 'Червень'
      }, {
        value: 7,
        label: 'Липень'
      }, {
        value: 8,
        label: 'Серпень'
      }, {
        value: 9,
        label: 'Вересень'
      }, {
        value: 10,
        label: 'Жовтень'
      }, {
        value: 11,
        label: 'Листопад'
      }, {
        value: 12,
        label: 'Грудень'
      }],
      'loading': 'Завантаження..',
      'noOptionsMessage': 'немає даних',
      'otherOption': 'інше',
      'placeholders': {
        'datePicker': {
          'day': 'День',
          'month': 'Місяць',
          'year': 'Рік'
        },
        'salaryCurrency': 'Виберіть валюту...'
      },
      'errors': {
        'required': 'Поле обов\'язково для заповнення',
        'minLength': 'Мінімальна кількість символів - {{count}}',
        'maxLength': 'Максимальна кількість символів - {{count}}',
        'moreThan': 'Число повинно бути більше {{more}}',
        'currency': 'Необхідно вказати валют',
        'phone': 'Невірний формат телефонного номера',
        'email': 'Невірний email',
        'emailChars': 'Невірний email (допустимі символи - латинські, цифри і _ - .)',
        'emailDomain': 'Невірний email домен (допустимі символи - латинські, цифри і - .)',
        'audioPermission': 'Доступ до мікрофона заблокований. Дозвольте доступ до мікрофона в налаштуваннях браузера',
        'cameraPermission': 'Доступ до камери заблокований. Дозвольте доступ до камери в налаштуваннях браузера',
        'uploadError': 'Не вдалося завантажити файл',
        'maximumFileSize_0': 'Максимальний розмір завантажуваного файлу: {{count}} мегабайт',
        'maximumFileSize_1': 'Максимальний розмір завантажуваного файлу: {{count}} мегабайти',
        'maximumFileSize_2': 'Максимальний розмір завантажуваного файлу: {{count}} мегабайт',
        'fileType': 'Невірний тип файлу, доступні типи: {{types}}',
        'fileTypeAudio': 'Неправильний тип файлу, виберіть аудіофайл',
        'fileTypeVideo': 'Невірний тип файлу, виберіть відеофайл',
        'composite': 'Блок обов\'язковий для заповнення',
        'incompleteDate': 'Необхідно вказати дату повністю',
        'captchaRequired': 'Необхідно пройти перевірку',
        'incorrectBirthDate': 'Date cant be earlier then birth date'
      },
      'invalidCaptcha': 'Невірно введена капча',
      'licenseError': 'В рамках тестового доступу досягнуто максимальну кількість відгуків. Зверніться до Відділу продажу ТОВ "Геліософт" і контакти відділу продажів (<a href=\"mailto:help@findy.ru\"> help@findy.ru </a>, <a href=\"tel:+74957836603\"> +7 (495) 783-66-03 </a> (9:00-18:00 за київським часом), <a href=\"tel:+79150216424\"> +7 (915) 021-64-24 </a>) ',
      'licenseExpired': 'Термін тестового доступу "30 днів" завершено. Зверніться до Відділу продаж ТОВ "Геліософт" (<a href="mailto:help@findy.ru">help@findy.ru</a>, <a href="tel:+74957836603">+7 (495) 783-66-03</a> (9:00-18:00 МСК), <a href="tel:+79150216424">+7 (915) 021-64-24</a>)'
    }
  },
  et: {
    translation: {
      'send': 'Esita',
      'addQuestionBlock': 'Lisama',
      'remove': 'Eemalda',
      'optional': ' (valikuline)',
      'cancel': 'Tühista',
      'save': 'Salvesta',
      'stopRecording': 'Lõpeta salvestamine',
      'startRecording': 'Alusta salvestamist',
      'upload': 'Laadi üles',
      'download': 'Lae alla',
      'recordAudio': 'Salvestage heli',
      'recordVideo': 'Salvesta video',
      'takePhoto': 'Pildista',
      'opdFormAccept': 'Nõus',
      'opdLabel': 'Olen nõus',
      'opdLink': 'isikuandmete töötlemine',
      'opdOffertaLabel': 'Nõustun tingimustega',
      'opdOffertaLink': 'avalik pakkumine',
      'MONTHS': [{
        value: 1,
        label: 'Jaanuar'
      }, {
        value: 2,
        label: 'Veebruar'
      }, {
        value: 3,
        label: 'Märts'
      }, {
        value: 4,
        label: 'Aprill'
      }, {
        value: 5,
        label: 'Mai'
      }, {
        value: 6,
        label: 'Juunil'
      }, {
        value: 7,
        label: 'Juuli'
      }, {
        value: 8,
        label: 'August'
      }, {
        value: 9,
        label: 'Septembrini'
      }, {
        value: 10,
        label: 'Oktoober'
      }, {
        value: 11,
        label: 'Novembrini'
      }, {
        value: 12,
        label: 'Detsembril'
      }],
      'loading': 'Laadimine...',
      'noOptionsMessage': 'Puuduvad andmed',
      'otherOption': 'Muu',
      'placeholders': {
        'datePicker': {
          'day': 'Päev',
          'month': 'Kuu',
          'year': 'Aasta'
        },
        'salaryCurrency': 'Valige valuuta...'
      },
      'errors': {
        'required': 'Nõutud väli',
        'minLength': 'Minimaalne tähtede arv - {{count}}',
        'maxLength': 'Maksimaalne tähtede arv - {{count}}',
        'moreThan': 'Arv peab olema suurem kui {{more}}',
        'currency': 'Vajalik valuuta',
        'phone': 'Vale telefoninumber',
        'email': 'Vale e-post',
        'emailChars': 'Vale e-post (kehtivad tähemärgid - tähtnumbrid _ - .)',
        'emailDomain': 'Vale e-posti domeen (kehtivad tähemärgid - tähtede numbrid - .)',
        'audioPermission': 'Juurdepääs mikrofonile on blokeeritud. Luba brauseri seadetes juurdepääs mikrofonile',
        'cameraPermission': 'Juurdepääs kaamerale on blokeeritud. Luba brauseri seadetes juurdepääs kaamerale',
        'uploadError': 'Faili üleslaadimine ebaõnnestus.',
        'maximumFileSize': 'Maksimaalne failisuurus: {{count}} megabaiti',
        'maximumFileSize_plural': 'Maksimaalne failisuurus: {{count}} megabaiti',
        'fileType': 'Kehtetu tüüp, saadaolevad tüübid:{{types}}',
        'fileTypeAudio': 'Vale tüüp, valige helifail',
        'fileTypeVideo': 'Vale tüüp, valige videofail',
        'composite': 'Nõutav plokk',
        'incompleteDate': 'Täiskuupäev on kohustuslik',
        'captchaRequired': 'Nõutav kontrollimine',
        'incorrectBirthDate': 'Date cant be earlier then birth date'
      },
      'invalidCaptcha': 'Sisestati sobimatu captcha',
      'licenseError': 'Testjuurdepääsuks on saavutatud maksimaalne vastuste arv. Võtke ühendust Heliosoft LLC müügiosakonnaga ja müügiosakonna kontaktidega (<a href=\"mailto:help@findy.ru\"> help@findy.ru </a>, <a href=\"tel:+74957836603\"> +7 (495) 783-66-03 </a> (9:00-18:00 MSK), <a href=\"tel:+79150216424\"> +7 (915) 021-64–24</a>)',
      'licenseExpired': 'Testjuurdepääsu periood "30 päeva" on möödas. Võtke ühendust "Heliosoft" LLC müügiosakonnaga ja müügiosakonna kontaktidega (<a href=\"mailto:help@findy.ru\"> help@findy.ru </a>, <a href=\"tel:+74957836603\"> +7 (495) 783-66-03 </a> (9:00-18:00 MSK), <a href=\"tel:+79150216424\"> +7 (915) 021-64–24</a>)'
    }
  },
  lt: {
    translation: {
      'send': 'Pateikti',
      'addQuestionBlock': 'Papildyti',
      'remove': 'Pašalinti',
      'optional': ' (neprivaloma)',
      'cancel': 'Atšaukti',
      'save': 'Išsaugoti',
      'stopRecording': 'Sustabdyti įrašymą',
      'startRecording': 'Pradėti įrašymą',
      'upload': 'Įkelti',
      'download': 'Parsisiųsti',
      'recordAudio': 'Įrašyti garsą',
      'recordVideo': 'Įrašyti vaizdo įrašą',
      'takePhoto': 'Nufotografuoti',
      'opdFormAccept': 'Priimti',
      'opdLabel': 'Aš sutinku su',
      'opdLink': 'asmens duomenų tvarkymas',
      'opdOffertaLabel': 'Sutinku su sąlygomis',
      'opdOffertaLink': 'viešas pasiūlymas',
      'MONTHS': [{
        value: 1,
        label: 'Sausis'
      }, {
        value: 2,
        label: 'Vasaris'
      }, {
        value: 3,
        label: 'Kovas'
      }, {
        value: 4,
        label: 'Balandis'
      }, {
        value: 5,
        label: 'Gegužė'
      }, {
        value: 6,
        label: 'Birželis'
      }, {
        value: 7,
        label: 'Liepa'
      }, {
        value: 8,
        label: 'Rugpjūtis'
      }, {
        value: 9,
        label: 'Rugsėjis'
      }, {
        value: 10,
        label: 'Spalis'
      }, {
        value: 11,
        label: 'Lapkritis'
      }, {
        value: 12,
        label: 'Gruodis'
      }],
      'loading': 'Įkeliama...',
      'noOptionsMessage': 'Duomenų nėra',
      'otherOption': 'Kita',
      'placeholders': {
        'datePicker': {
          'day': 'Diena',
          'month': 'Mėnuo',
          'year': 'Metai'
        },
        'salaryCurrency': 'Pasirinkite valiutą...'
      },
      'errors': {
        'required': 'Privalomas laukelis',
        'minLength': 'Minimalus raidžių skaičius - {{count}}',
        'maxLength': 'Maksimalus raidžių skaičius - {{count}}',
        'moreThan': 'Skaičius turi būti didesnis nei {{more}}',
        'currency': 'Reikalinga valiuta',
        'phone': 'Neteisingas telefono numeris',
        'email': 'Neteisingas el. pašto adresas',
        'emailChars': 'Neteisingas el. Paštas (galiojantys simboliai - raidžių skaičiai _ - .)',
        'emailDomain': 'Neteisingas el. Pašto domenas (galiojantys simboliai - raidžių skaičiai - .)',
        'audioPermission': 'Prieiga prie mikrofono yra užblokuota. Leisti prieigą prie mikrofono naršyklės nustatymuose',
        'cameraPermission': 'Prieiga prie kameros užblokuota. Leiskite prieigą prie kameros naršyklės nustatymuose',
        'uploadError': 'Nepavyko įkelti failo.',
        'maximumFileSize': 'Maksimalus failo dydis: {{count}} megabaitai',
        'maximumFileSize_plural': 'Didžiausias failo dydis: {{count}} megabaitų',
        'fileType': 'Netinkamas tipas, galimi tipai: {{types}}',
        'fileTypeAudio': 'Netinkamas tipas, pasirinkite garso failą',
        'fileTypeVideo': 'Netinkamas tipas, pasirinkite vaizdo failą',
        'composite': 'Reikalingas blokas',
        'incompleteDate': 'Būtina nurodyti pilną datą',
        'captchaRequired': 'Būtina patvirtinimas',
        'incorrectBirthDate': 'Data negali būti ankstesnė už gimimo datą'
      },
      'invalidCaptcha': 'Neteisingas CAPTCHA kodas',
      'licenseError': 'Pasiektas maksimalus bandymų prieigos atsakymų skaičius. Susisiekite su „Heliosoft LLC“ pardavimo skyriumi ir pardavimo skyriaus kontaktais (<a href=\"mailto:help@findy.ru\"> help@findy.ru </a>, <a href=\"tel:+74957836603\"> +7 (495) 783-66-03 </a> (9:00-18:00 Maskvos laiku), <a href=\"tel:+79150216424\"> +7 (915) 021-64–24 </a>)',
      'licenseExpired': 'Bandymo prieigos laikotarpis „30 dienų“ baigėsi. Susisiekite su „Heliosoft“ LLC pardavimų skyriumi ir pardavimo skyriaus kontaktais (<a href="mailto:help@findy.ru"> help@findy.ru </a>, <a href = "tel: +74957836603 "> +7 (495) 783-66-03 </a> (9:00-18:00 Maskvos laiku), <a href="tel: +79150216424"> + 7 (915) 021-64-24 < /a>)'
    }
  },
  lv: {
    translation: {
      'send': 'Pateikti',
      'addQuestionBlock': 'Pievienot',
      'remove': 'Nonemt',
      'optional': ' (neobligāti)',
      'cancel': 'Atcelt',
      'save': 'Saglabāt',
      'stopRecording': 'Pārtraukt ierakstīšanu',
      'startRecording': 'Sākt ierakstīšanu',
      'upload': 'Augšupielādēt',
      'download': 'Lejupielādēt',
      'recordAudio': 'Ierakstīt audio',
      'recordVideo': 'Ierakstīt video',
      'takePhoto': 'Uzņemt attēlu',
      'opdFormAccept': 'Pieņemt',
      'opdLabel': 'Es tam piekrītu',
      'opdLink': 'personas datu apstrāde',
      'opdOffertaLabel': 'Es piekrītu noteikumiem',
      'opdOffertaLink': 'publiskais piedāvājums',
      'MONTHS': [{
        value: 1,
        label: 'Janvāris'
      }, {
        value: 2,
        label: 'Februāris'
      }, {
        value: 3,
        label: 'Martā'
      }, {
        value: 4,
        label: 'Aprīlis'
      }, {
        value: 5,
        label: 'Maijs'
      }, {
        value: 6,
        label: 'Jūnijs'
      }, {
        value: 7,
        label: 'Jūlijs'
      }, {
        value: 8,
        label: 'Augusts'
      }, {
        value: 9,
        label: 'Septembris'
      }, {
        value: 10,
        label: 'Oktobris'
      }, {
        value: 11,
        label: 'Novembrī'
      }, {
        value: 12,
        label: 'Decembris'
      }],
      'loading': 'Notiek ielāde...',
      'noOptionsMessage': 'Nav datu',
      'otherOption': 'Cits',
      'placeholders': {
        'datePicker': {
          'day': 'Diena',
          'month': 'Mēnesis',
          'year': 'Gads'
        },
        'salaryCurrency': 'Atlasiet valūtu...'
      },
      'errors': {
        'required': 'Obligāts lauks',
        'minLength': 'Minimālais burtu skaits - {{count}}',
        'maxLength': 'Maksimālais burtu skaits - {{count}}',
        'moreThan': 'Skaitlim jābūt lielākam par {{more}}',
        'currency': 'Nepieciešama valūta',
        'phone': 'Nederīgs tālruņa numurs',
        'email': 'Nepareizs e-pasts',
        'emailChars': 'Nederīgs e-pasts (derīgas rakstzīmes - burtu cipari _ - .)',
        'emailDomain': 'Nederīgs e-pasta domēns (derīgas rakstzīmes - burtu numuri - .)',
        'audioPermission': 'Piekļuve mikrofonam ir bloķēta. Atļaut piekļuvi mikrofonam pārlūka iestatījumos',
        'cameraPermission': 'Piekļuve kamerai ir bloķēta. Pārlūka iestatījumos atļaujiet piekļuvi kamerai',
        'uploadError': 'Neizdevās augšupielādēt failu.',
        'maximumFileSize': 'Maksimālais faila lielums: {{count}} megabaits',
        'maximumFileSize_plural': 'Maksimālais faila lielums: {{count}} megabaiti',
        'fileType': 'Nederīgs tips, pieejamie veidi: {{types}}',
        'fileTypeAudio': 'Nederīgs tips, atlasiet audio failu',
        'fileTypeVideo': 'Nederīgs tips, atlasiet video failu',
        'composite': 'Nepieciešamais bloks',
        'incompleteDate': 'Nepieciešams norādīt pilnu datumu',
        'captchaRequired': 'Nepieciešama verifikācija',
        'incorrectBirthDate': 'Date cant be earlier then birth date'
      },
      'invalidCaptcha': 'Ievadīta nederīga captcha',
      'licenseError': 'Testa piekļūšanai ir sasniegts maksimālais atbilžu skaits. Sazinieties ar Heliosoft LLC pārdošanas nodaļu un pārdošanas nodaļas kontaktpersonām (<a href=\"mailto:help@findy.ru\"> help@findy.ru </a>, <a href=\"tel:+74957836603\"> +7 (495) 783-66-03 </a> (9:00-18:00 pēc Maskavas laika), <a href=\"tel:+79150216424\"> +7 (915) 021-64–24 </a>)',
      'licenseExpired': 'Pārbaudes piekļuves periods "30 dienas" ir beidzies. Sazinieties ar "Heliosoft" LLC Pārdošanas Nodaļu un pārdošanas nodaļas kontaktiem (<a href="mailto:help@findy.ru"> help@findy.ru </a>, <a href="tel:+74957836603"> +7 (495) 783-66-03 </a> (9:00-18:00 Maskavas laiks), <a href="tel: +79150216424"> + 7 (915) 021-64-24 </a>) '
    }
  },
  kz: {
    translation: {
      'send': 'Жіберу',
      'addQuestionBlock': 'Қосу',
      'remove': 'Жою',
      'optional': ' (міндетті емес)',
      'cancel': 'Болдырмау',
      'save': 'Сақтау',
      'stopRecording': 'Жазуды тоқтату',
      'startRecording': 'Жазуды бастау',
      'upload': 'Жүктеу',
      'download': 'Жүктеу',
      'recordAudio': 'Аудио жазу',
      'recordVideo': 'Бейне жазу',
      'takePhoto': 'Фотоға түсіру',
      'opdFormAccept': 'Келісемін',
      'opdLabel': 'Мен келісемін',
      'opdLink': 'дербес деректерді өңдеу',
      'opdOffertaLabel': 'Мен шарттарды қабылдаймын',
      'opdOffertaLink': 'ашық ұсыныс',
      'MONTHS': [{
        value: 1,
        label: 'қаңтар'
      }, {
        value: 2,
        label: 'ақпан'
      }, {
        value: 3,
        label: 'наурыз'
      }, {
        value: 4,
        label: 'сәуір'
      }, {
        value: 5,
        label: 'мамыр'
      }, {
        value: 6,
        label: 'маусым'
      }, {
        value: 7,
        label: 'шілде'
      }, {
        value: 8,
        label: 'тамыз'
      }, {
        value: 9,
        label: 'қыркүйек'
      }, {
        value: 10,
        label: 'қазан'
      }, {
        value: 11,
        label: 'қараша'
      }, {
        value: 12,
        label: 'желтоқсан'
      }],
      'loading': 'Жүктелуде...',
      'noOptionsMessage': 'Деректер жоқ',
      'otherOption': 'Басқа',
      'placeholders': {
        'datePicker': {
          'day': 'Күн',
          'month': 'Ай',
          'year': 'Жыл'
        },
        'salaryCurrency': 'Валюта таңдау...'
      },
      'errors': {
        'required': 'Бұл өріс міндетті',
        'minLength': 'Таңбалардың ең аз саны - {{count}}',
        'maxLength': 'Таңбалардың максималды саны - {{count}}',
        'moreThan': 'Сан {{more}} үлкен болуы керек',
        'currency': 'Сіз валютаны көрсетуіңіз керек',
        'phone': 'Телефон нөмірінің форматы жарамсыз',
        'email': 'жарамсыз электрондық пошта',
        'emailChars': 'Жарамсыз электрондық пошта (жарамды таңбалар -латын цифрлары _ -.)',
        'emailDomain': 'Жарамсыз электрондық пошта домені (рұқсат етілген таңбалар - латын цифрлары -.)',
        'audioPermission': 'Микрофонға кіруге тыйым салынды. Браузер параметрлерінде микрофонға кіруге рұқсат беру',
        'cameraPermission': 'Камераға кіруге тыйым салынды. Браузер параметрлерінде камераға кіруге рұқсат етіңіз',
        'uploadError': 'Файл жүктелмеді',
        'maximumFileSize_0': 'Жүктеу файлының максималды өлшемі: {{count}} мегабайт',
        'maximumFileSize_1': 'Файлдың максималды жүктелуі: {{count}} мегабайт',
        'maximumFileSize_2': 'Жүктеу файлының максималды өлшемі: {{count}} мегабайт',
        'fileType': 'Файл түрі жарамсыз, қолжетімді түрлері: {{types}}',
        'fileTypeAudio': 'Файл түрі жарамсыз, аудио файлды таңдаңыз',
        'fileTypeVideo': 'Файл түрі жарамсыз, бейне файлды таңдаңыз',
        'composite': 'Блок қажет',
        'incompleteDate': 'Сіз толық күнді көрсетуіңіз керек',
        'captchaRequired': 'Тексеру қажет',
        'incorrectBirthDate': 'Date cant be earlier then birth date'
      },
      'invalidCaptcha': 'Жарамсыз captcha енгізілді',
      'licenseError': 'Тестке кіру үшін жауаптардың максималды санына жетті. Heliosoft LLC сату бөліміне және сату бөлімінің байланыстарына хабарласыңыз (<a href=\"mailto:help@findy.ru\"> help@findy.ru </a>, <a href =\"tel:+74957836603\"> +7 (495) 783-66-03 </a> (Мәскеу уақытымен 9:00-18:00), <a href=\"tel:+79150216424\"> +7 (915) 021-64-24 </a>) ',
      'licenseExpired': ''
    }
  },
  th: {
    translation: {
      'send': 'ส่ง',
      'addQuestionBlock': 'เพิ่ม',
      'remove': 'ลบ',
      'optional': ' (ไม่บังคับ)',
      'cancel': 'ยกเลิก',
      'save': 'บันทึก',
      'stopRecording': 'หยุดการบันทึก',
      'startRecording': 'เริ่มการบันทึก',
      'upload': 'อัปโหลด',
      'download': 'ดาวน์โหลด',
      'recordAudio': 'บันทึกเสียง',
      'recordVideo': 'บันทึกวิดีโอ',
      'takePhoto': 'ถ่ายภาพ',
      'opdFormAccept': 'ตกลง',
      'opdLabel': 'ฉันยินยอม',
      'opdLink': 'การประมวลผลข้อมูลส่วนบุคคล',
      'opdOffertaLabel': 'ฉันยอมรับข้อกำหนด',
      'opdOffertaLink': 'ข้อเสนอสาธารณะ',
      'MONTHS': [{
        value: 1,
        label: 'มกราคม'
      }, {
        value: 2,
        label: 'กุมภาพันธ์'
      }, {
        value: 3,
        label: 'มีนาคม'
      }, {
        value: 4,
        label: 'เมษายน'
      }, {
        value: 5,
        label: 'พฤษภาคม'
      }, {
        value: 6,
        label: 'มิถุนายน'
      }, {
        value: 7,
        label: 'กรกฎาคม'
      }, {
        value: 8,
        label: 'สิงหาคม'
      }, {
        value: 9,
        label: 'กันยายน'
      }, {
        value: 10,
        label: 'ตุลาคม'
      }, {
        value: 11,
        label: 'พฤศจิกายน'
      }, {
        value: 12,
        label: 'ธันวาคม'
      }],
      'loading': 'กำลังโหลด...',
      'noOptionsMessage': 'ไม่มีข้อมูล',
      'otherOption': 'อื่นๆ',
      'placeholders': {
        'datePicker': {
          'day': 'วัน',
          'month': 'เดือน',
          'year': 'ปี'
        },
        'salaryCurrency': 'เลือกสกุลเงิน...'
      },
      'errors': {
        'required': 'จำเป็นต้องกรอกข้อมูล',
        'minLength': 'จำนวนอักขระขั้นต่ำคือ {{count}}',
        'maxLength': 'จำนวนอักขระสูงสุดคือ {{count}}',
        'moreThan': 'จำนวนต้องมากกว่า {{more}}',
        'currency': 'คุณต้องระบุสกุลเงิน',
        'phone': 'รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง',
        'email': 'อีเมลไม่ถูกต้อง',
        'emailChars': 'อีเมลไม่ถูกต้อง (อักขระที่ถูกต้องคือตัวเลขละติน _ -.)',
        'emailDomain': 'โดเมนอีเมลไม่ถูกต้อง (อักขระที่อนุญาต - ตัวเลขละติน -.)',
        'audioPermission': 'การเข้าถึงไมโครโฟนถูกบล็อก อนุญาตให้เข้าถึงไมโครโฟนในการตั้งค่าเบราว์เซอร์',
        'cameraPermission': 'การเข้าถึงกล้องถูกบล็อก อนุญาตให้เข้าถึงกล้องในการตั้งค่าเบราว์เซอร์',
        'uploadError': 'ไม่สามารถอัปโหลดไฟล์',
        'maximumFileSize_0': 'ขนาดไฟล์อัพโหลดสูงสุด: {{count}} เมกะไบต์',
        'maximumFileSize_1': 'ขนาดไฟล์อัพโหลดสูงสุด: {{count}} เมกะไบต์',
        'maximumFileSize_2': 'ขนาดไฟล์อัพโหลดสูงสุด: {{count}} เมกะไบต์',
        'fileType': 'ประเภทไฟล์ไม่ถูกต้อง ประเภทที่มี: {{types}}',
        'fileTypeAudio': 'ประเภทไฟล์ไม่ถูกต้อง เลือกไฟล์เสียง',
        'fileTypeVideo': 'ประเภทไฟล์ไม่ถูกต้อง เลือกไฟล์วิดีโอ',
        'composite': 'จำเป็นต้องบล็อก',
        'incompleteDate': 'คุณต้องระบุวันที่แบบเต็ม',
        'captchaRequired': 'ต้องยืนยัน',
        'incorrectBirthDate': 'Date cant be earlier then birth date'
      },
      'validCaptcha': 'ป้อน captcha ไม่ถูกต้อง',
      'licenseError': 'มีการตอบกลับถึงจำนวนสูงสุดสำหรับการเข้าถึงการทดสอบแล้ว ติดต่อฝ่ายขายของ Heliosoft LLC และผู้ติดต่อของฝ่ายขาย (<a href=\"mailto:help@findy.ru\"> help@findy.ru </a>, <a href=\"tel:+74957836603\"> +7 (495) 783-66-03 </a> (9:00-18:00 น. เวลามอสโก), ​​<a href=\"tel:+79150216424\"> +7 (915) 021-64-24 </a>) ',
      'licenseExpired': ''
    }
  },
  uz: {
    translation: {
      'send': 'Yuborish',
      'addQuestionBlock': 'Qo\'shish',
      'remove': 'O\'chirish',
      'optional': ' (ixtiyoriy)',
      'cancel': 'Bekor qilish',
      'save': 'Saqlash',
      'stopRecording': 'Yozishni to\'xtatish',
      'startRecording': 'Yozishni boshlash',
      'upload': 'Yuklash',
      'download': 'Yuklab olish',
      'recordAudio': 'Ovoz yozish',
      'recordVideo': 'Videoni yozib olish',
      'takePhoto': 'Suratga olish',
      'opdFormAccept': 'Qabul qilaman',
      'opdLabel': 'Men roziman',
      'opdLink': 'shaxsiy ma\'lumotlarni qayta ishlash',
      'opdOffertaLabel': 'Men shartlarni qabul qilaman',
      'opdOffertaLink': 'ommaviy taklif',
      'MONTHS': [{
        value: 1,
        label: 'yanvar'
      }, {
        value: 2,
        label: 'fevral'
      }, {
        value: 3,
        label: 'mart'
      }, {
        value: 4,
        label: 'aprel'
      }, {
        value: 5,
        label: 'may'
      }, {
        value: 6,
        label: 'iyun'
      }, {
        value: 7,
        label: 'iyul'
      }, {
        value: 8,
        label: 'avgust'
      }, {
        value: 9,
        label: 'sentyabr'
      }, {
        value: 10,
        label: 'oktyabr'
      }, {
        value: 11,
        label: 'noyabr'
      }, {
        value: 12,
        label: 'dekabr'
      }],
      'loading': 'Yuklanmoqda...',
      'noOptionsMessage': 'Ma\'lumot yo\'q',
      'otherOption': 'Boshqa',
      'placeholders': {
        'datePicker': {
          'day': 'Kun',
          'month': 'Oy',
          'year': 'Yil'
        },
        'salaryCurrency': 'Valyutani tanlang...'
      },
      'errors': {
        'required': 'Bu maydon majburiy',
        'minLength': 'Belgilarning minimal soni: {{count}}',
        'maxLength': 'Belgilarning maksimal soni: {{count}}',
        'moreThan': 'Raqam {{more}} dan katta bo\'lishi kerak',
        'currency': 'Siz valyutani ko\'rsatishingiz kerak',
        'phone': 'Telefon raqami formati noto\'g\'ri',
        'email': 'Noto\'g\'ri elektron pochta',
        'emailChars': 'Noto\'g\'ri elektron pochta (haqiqiy belgilar lotincha raqamlar _ -.)',
        'emailDomain': 'Noto\'g\'ri elektron pochta domeni (ruxsat berilgan belgilar - lotin raqamlari -.)',
        'audioPermission': 'Mikrofonga kirish bloklandi. Brauzer sozlamalarida mikrofonga kirishga ruxsat bering',
        'cameraPermission': 'Kameraga kirish bloklandi. Brauzer sozlamalarida kameraga kirishga ruxsat bering',
        'uploadError': 'Fayl yuklanmadi',
        'maximumFileSize_0': 'Maksimal yuklangan fayl hajmi: {{count}} megabayt',
        'maximumFileSize_1': 'Maksimal yuklangan fayl hajmi: {{count}} megabayt',
        'maximumFileSize_2': 'Maksimal yuklangan fayl hajmi: {{count}} megabayt',
        'fileType': 'Fayl turi noto\'g\'ri, mavjud turlari: {{types}}',
        'fileTypeAudio': 'Fayl turi noto\'g\'ri, audio faylni tanlang',
        'fileTypeVideo': 'Fayl turi noto\'g\'ri, video faylni tanlang',
        'composite': 'Bloklash shart',
        'incompleteDate': 'To\'liq sanani ko\'rsatish kerak',
        'captchaRequired': 'Tasdiqlash kerak',
        'incorrectBirthDate': 'Date cant be earlier then birth date'
      },
      'invalidCaptcha': "Noto'g'ri captcha kiritildi",
      'licenseError': 'Testlarga kirish uchun maksimal javoblar soniga erishildi. "Heliosoft" MChJ savdo bo\'limi va savdo bo\'limi bilan bog\'laning (< ahref=\"mailto:help@findy.ru\"> help@findy.ru </a>, <a href =\"tel:+ 74957836603\"> +7 (495) 783-66-03 </a> (Moskva vaqti bilan 9:00-18:00), <a href=\"tel:+79150216424\"> +7 (915) 021-64-24 </a>)',
      'licenseExpired': ''
    }
  }
};
exports.TRANSLATIONS = TRANSLATIONS;
var RU = 'ru';
exports.RU = RU;